export default __webpack_public_path__ + "static/media/io.35dfa7ba.svg";